<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Update Received Date</h4>
</div>
<div class="modal-body">
  <form (ngSubmit)="searchClaim()" #claimSearchForm="ngForm" novalidate>
    <div class="row">
      <div class="col-md-5">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="claimSearchTerm"
            name="claimSearch"
            placeholder="Claim #"
          />
        </div>
      </div>
      <div class="col-md-1" style="padding-left: 0px">
        <button type="submit" class="btn btn-success pull-left">Search</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <div class="form-group" [innerHTML]="claimSearchResult"></div>
      </div>
    </div>
    <div class="row" *ngIf="originalClaim">
      <div class="col-md-10">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="claimAdjustedReason"
          name="claimAdjustedReasonInput"
          placeholder="Reason for change"
        />
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="claimAdjustedReceivedDateSubmit($event)"
    [disabled]="!originalClaim"
  >
    OK
  </button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
